module.exports = __webpack_public_path__ + "static/krzysiek-avatar-848d4d51c7361c5c37417b3a70fae5b0.webp";